module.exports = __webpack_public_path__ + "static/img/doctor-specialist-physician-512.cec0b055.png";